var styles = {"item":"Accordion-module_item__3-4D4","trigger":"Accordion-module_trigger__3fCPO","text":"Accordion-module_text__ZOfRg","icon":"Accordion-module_icon__2uA_W","panel":"Accordion-module_panel__1arxA","expanded":"Accordion-module_expanded__rUH_H","collapsed":"Accordion-module_collapsed__3DQ4M","content":"Accordion-module_content__2y5QM","hidden":"Accordion-module_hidden__1DXJq"};

export { styles as default };
//# sourceMappingURL=Accordion.module.css.js.map
